import { useRef } from 'react';
import './IntroSectionComponent.css';
import { useScrollRange } from '../responsive/scroll';

const revealed = { filter: 'blur(0px)', opacity: 1 };

const IntroSectionComponent = () => {
    const sectionRef = useRef(null);
    // Box and text un-blur while the section is in place (were scroll ranges 2200–2900 and 2300–2900)
    const showBox = useScrollRange(sectionRef, 0.177, -0.734);
    const showText = useScrollRange(sectionRef, 0.047, -0.734);
    const giveBackBox = () => {
        return <div 
            className="give-back-box"
            style={showBox ? revealed : {}}
            >
                <span
                    className="give-back-text"
                    style={showText ? revealed : {}}
                >
                    What if we could give
                    time back to the city?
                </span>
        </div>
    };


    return <div ref={sectionRef} className="viewport grid-parent story-layout">
        <span className="title story-title">The Story</span>
        <p className="great-city-p">
            In every great city, movement defines life. <br />
            But in New York, it becomes congestion and delay
            especially when seconds matter most. <br />
        </p>
        <p className="ordinary-day-p">
            It started on an ordinary day — an ambulance stuck in traffic,
            a siren echoing through a sea of unmoving cars.
            That moment revealed something profound.
            Maps move data. We'll move people.
        </p>
       {giveBackBox()}
    </div>
}

export default IntroSectionComponent;